import React from 'react';
import { ExternalLink } from 'lucide-react';
import { formatTextWithLinks } from '../../utils/linkHelpers';

/**
 * Component that renders text with URLs converted to clickable "Event Link" buttons
 * @param {Object} props
 * @param {string} props.text - The text content that may contain URLs
 * @param {string} props.className - Additional CSS classes for the container
 * @returns {JSX.Element}
 */
export default function TextWithLinks({ text, className = '' }) {
  if (!text) return null;
  
  const parts = formatTextWithLinks(text);
  
  return (
    <span className={className}>
      {parts.map((part, index) => {
        if (typeof part === 'string') {
          return part;
        }
        
        if (part.type === 'link') {
          return (
            <a
              key={part.key || `link-${index}`}
              href={part.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 px-2 py-1 bg-azure-100 text-azure-700 hover:bg-azure-200 rounded text-xs font-medium transition-colors mx-1"
              onClick={(e) => {
                e.stopPropagation(); // Prevent event card click when clicking link
              }}
            >
              <ExternalLink className="w-3 h-3" />
              Event Link
            </a>
          );
        }
        
        return part;
      })}
    </span>
  );
}